import { GroupField } from '@prismicio/client';
import Marquee from 'react-fast-marquee';
import {
  LoanUsesSliceCarouselPrimaryCardsItem,
  Simplify,
} from '../../../../../../../prismicio-types';
import { LoanUsesCard } from '../LoanUsesCard/LoanUsesCard';
import { useVisible } from '@/hooks';

import styles from './desktopCards.module.scss';

interface DesktopCardProps {
  cards: GroupField<Simplify<LoanUsesSliceCarouselPrimaryCardsItem>>;
}

export const DesktopCards = ({ cards }: DesktopCardProps) => {
  const [isVisible, id] = useVisible();
  return (
    <div
      className={`${styles.desktop} ${isVisible ? styles.isVisible : ''}`}
      id={id}
    >
      <Marquee gradient={false} speed={100} pauseOnHover>
        {cards.map((item, index) => (
          <LoanUsesCard
            key={item.description}
            item={item}
            variant="desktop"
            index={index}
          />
        ))}
      </Marquee>
    </div>
  );
};
